import { useContext } from 'react';
import ExportTranscriptModalContext from './ExportTranscriptModalContext';

export default function useExportTranscriptModalContext() {
  const context = useContext(ExportTranscriptModalContext);

  if (context === undefined) {
    throw new Error(
      'useExportTranscriptModalContext must be used within ExportTranscriptModalProvider',
    );
  }

  return context;
}
